module.exports = __webpack_public_path__ + "img/progression.b2c66fd9.jpg";